import { Link } from 'react-router-dom';
import { siteConfig, footerLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-screen-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
            <div>
              <Link to="/" className="flex items-center gap-3 mb-4 group">
                <div className="w-10 h-10 rounded-full bg-secondary-700 flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                  <i className="ri-eye-line text-accent-400 text-xl"></i>
                </div>
                <span className="text-xl font-heading font-bold text-background-50 tracking-wide">
                  {siteConfig.name}
                </span>
              </Link>
              <p className="text-sm text-secondary-300 leading-relaxed mb-6">
                {siteConfig.description}
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:bg-accent-500 transition-all duration-200 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:bg-accent-500 transition-all duration-200 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:bg-accent-500 transition-all duration-200 cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-base"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-label font-semibold uppercase tracking-widest text-secondary-400 mb-5">
                {footerLinks.platform.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {footerLinks.platform.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-secondary-300 hover:text-background-50 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-label font-semibold uppercase tracking-widest text-secondary-400 mb-5">
                {footerLinks.about.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {footerLinks.about.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-secondary-300 hover:text-background-50 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-label font-semibold uppercase tracking-widest text-secondary-400 mb-5">
                {footerLinks.legal.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {footerLinks.legal.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-secondary-300 hover:text-background-50 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-16 md:mt-20 pt-8 border-t border-secondary-700/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-secondary-400">
                &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有 | 本站内容仅供娱乐参考
              </p>
              <p className="text-xs text-secondary-400">
                <a href="http://shangremen.cn/" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-secondary-300 transition-colors duration-200">
                  京ICP备2024000001号
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative overflow-hidden bg-secondary-950 py-8 md:py-12">
        <div className="absolute inset-0 opacity-5">
          <div className="text-[120px] md:text-[180px] font-heading font-black text-background-50 leading-none tracking-tighter text-center whitespace-nowrap select-none">
            吃瓜网在线
          </div>
        </div>
      </div>
    </footer>
  );
}